// extracted by mini-css-extract-plugin
export default {"card":"yP","cardrow":"zP","cardcentered":"AP","details":"BP","imgwrapper":"CP","img":"EP","category":"FP","name":"GP","copy":"HP","detailsbtn":"IP","remove":"JP","price":"KP","netPrice":"LP","regularPrice":"MP","label":"NP"};
    if(module.hot) {
      // 1713361652934
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  